export default __webpack_public_path__ + "atomic/_patterns/02-molecules/content-section-call-to-action/_content-section-call-to-action.twig";